import React from 'react';
import useStyles from './styles';
import Tickers from '../Tickers/Tickers';
import {
  AppBar,
  Button,
  Container,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Fade from '@mui/material/Fade';
import { useNavigate } from 'react-router-dom';
import Ticker from 'react-ticker';
import { alpha } from '@mui/material';
import Logo from '../../utils/logo/Logo.png';
import SRM from '../../utils/logo/SRM.jpg';

export const Navbar = props => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTab = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div
      className={classes.root}
    // styles={{
    //   position: 'fixed',
    // }}
    >
      <AppBar
        position="absolute"
        color="default"
        className={classes.AppBar}
        sx={{
          boxShadow: '0px 0px 0px 0px',
          // backgroundColor: '#fff',
          position: 'fixed',
          width: '100%',
          // marginRight: ['0px', '0px', '0px'],
          // top: '0px',
          // left: ['0px', '0px', '-40px', '0px', '0px'],
          zIndex: '1',
          // width: ['100%', '100%', '100%', '100%', '100%'],
        }}
      >
        <Container fixed sx={{ maxWidth: '100vw !important' }}>
          <Grid
            Container
            item
            sm={12}
            xs={12}
            sx={
              {
                // width: [400, "100%"],
              }
            }
          >
            <Toolbar>
              <Grid
                className={classes.grow}
                sx={{
                  px: [0, 1, 1, 1, 1],
                }}
              >
                <Button
                  className={classes.mainLogo}
                  sx={{
                    color: '#FF7345',
                    ight: 'bold',
                    fontFamily: 'Sora',
                    fontSize: ['15px', '16px', '18px'],
                    marginTop: '10px',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    navigate('/');
                  }}
                >

                  <img style={{ width: '80px' }} src={SRM} alt="" />
                </Button>
                <Button
                  className={classes.mainLogo}
                  sx={{
                    color: '#FF7345',
                    ight: 'bold',
                    fontFamily: 'Sora',
                    fontSize: ['15px', '16px', '18px'],
                    marginTop: '10px',
                  }}
                  onClick={e => {
                    e.preventDefault();
                    navigate('/');
                  }}
                >
                  <img style={{ width: '45px' }} src={Logo} alt="" />
                </Button>
              </Grid>

              {isMobile || isTab ? (
                <div className={classes.menuIcon}>
                  <IconButton onClick={handleClick}>
                    <MenuIcon />
                  </IconButton>

                  <Menu
                    id="fade-menu"
                    MenuListProps={{
                      'aria-labelledby': 'fade-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    TransitionComponent={Fade}
                  >
                    <MenuItem
                      onClick={() => {
                        navigate('/about-us');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      About Us
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        navigate('/newsletter');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      Newsletter
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        navigate('/announcements');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      Announcements
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        navigate('/blogs');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      Blogs
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        navigate('/events');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      Events
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        navigate('/contact-us');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                      }}
                    >
                      Contact Us
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        navigate('/login');
                      }}
                      sx={{
                        fontFamily: 'Sora',
                        color: '#FFF',
                        fontWeight: 'bold',
                        backgroundColor: '#FF7345',
                        borderRadius: 1,
                        marginLeft: 1,
                        marginRight: 1,
                        '&:hover': {
                          backgroundColor: 'smoke',
                        },
                      }}
                    >
                      Login
                    </MenuItem>
                  </Menu>
                </div>
              ) : (
                <>
                  <MenuItem
                    // className={classes.buttonFontSize}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                    onClick={e => {
                      e.preventDefault();
                      navigate('/about-us');
                    }}
                  >
                    About Us
                  </MenuItem>

                  <MenuItem
                    // className={classes.buttonFontSize}
                    onClick={() => {
                      navigate('/newsletter');
                    }}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                  >
                    Newsletter
                  </MenuItem>

                  <MenuItem
                    // className={classes.buttonFontSize}
                    onClick={() => {
                      navigate('/announcements');
                    }}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                  >
                    Announcements
                  </MenuItem>
                  <MenuItem
                    // className={classes.buttonFontSize}
                    onClick={() => {
                      navigate('/blogs');
                    }}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                  >
                    Blogs
                  </MenuItem>
                  <MenuItem
                    // className={classes.buttonFontSize}
                    onClick={() => {
                      navigate('/events');
                    }}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                  >
                    Events
                  </MenuItem>
                  <MenuItem
                    // className={classes.buttonFontSize}
                    sx={{
                      fontFamily: 'Sora',
                      color: '#223230',
                      marginTop: '10px',
                    }}
                    onClick={e => {
                      e.preventDefault();
                      navigate('/contact-us');
                    }}
                  >
                    Contact Us
                  </MenuItem>
                  <Button
                    // className={classes.buttonFontSize}
                    sx={{
                      fontWeight: 'bolder',
                      fontFamily: 'Sora',
                      color: '#FF7345',
                      backgroundColor: '#FF7345 0% 0% no-repeat padding-box',
                      marginLeft: [0, 0, 6, 12, 12],
                      marginTop: '10px',
                      '&:hover': {
                        backgroundColor: 'smoke',
                      },
                    }}
                    onClick={e => {
                      e.preventDefault();
                      navigate('/login');
                    }}
                  >
                    Login
                  </Button>
                </>
              )}
            </Toolbar>
          </Grid>
        </Container>
        <Tickers />
      </AppBar>
    </div>
  );
};
